import { AppEnvironment } from '@dev-portal/environments';
import { baseEnvironmentValues, scope } from './config/base-environment-values';

const baseApiUrl: string = 'https://auth.preprod.nursa.com/api';
const authServerUrl: string = 'https://auth.preprod.nursa.com/oidc';

export const environment: AppEnvironment = {
  ...baseEnvironmentValues,
  preprod: true,
  name: 'Preprod',
  host: 'https://developers.preprod.nursa.com',
  apiUrl: baseApiUrl,
  authServerUrl: authServerUrl,
  auth0Config: {
    domain: authServerUrl,
    clientId: 'lgtG2WtMPXIa63SGbdDFnHrCafZEhG1K',
    issuer: 'https://auth.preprod.nursa.com/',
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
    authorizationParams: {
      scope,
      redirect_uri: `${window.location.origin}`,
      audience: 'https://developers.preprod.nursa.com/'
    },
    httpInterceptor: {
      allowedList: [{ uri: `${baseApiUrl}/*` }]
    }
  }
} as AppEnvironment;
